// 菜单 侧边栏
export default [{
  path: '/index',
  title: '首页',
  icon: 'home'
}];